import { createSetters } from 'map-state-vmodel'

/**
 * Sign.js
 * 
 * Site name will be added here
 */

// initial state
const state = {
  site_name: null
};

// getters
const getters = {};

// actions
const actions = {};

// mutations
const mutations = {
  ...createSetters(state)
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
